import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'

export const container = css`
  padding: ${spacing(2)};
  background-color: ${colors.black};
  min-height: 100vh;
`

export const dateSection = css`
  margin-bottom: ${spacing(3)};
`

export const dateHeader = css`
  text-align: center;
  margin-bottom: ${spacing(2)};
`

export const dateText = css`
  color: ${colors.white100};
  margin: 0;
`

export const gamesContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1.5)};
`

export const loadingPlaceholder = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`

export const loadingText = css`
  color: ${colors.white100};
`

export const errorContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: ${colors.red};
`

export const emptyContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: ${colors.white100};
`

